{
  "labels": {
    "paste": "Вставить",
    "pasteAsPlaintext": "Вставить как обычный текст",
    "pasteCharts": "Вставить диаграммы",
    "selectAll": "Выбрать всё",
    "multiSelect": "Добавить элемент в выделенный фрагмент",
    "moveCanvas": "Переместить холст",
    "cut": "Вырезать",
    "copy": "Копировать",
    "copyAsPng": "Скопировать в буфер обмена как PNG",
    "copyAsSvg": "Скопировать в буфер обмена как SVG",
    "copyText": "Скопировать в буфер обмена как текст",
    "copySource": "Скопировать источник в буфер обмена",
    "convertToCode": "Преобразовать в код",
    "bringForward": "Переместить вперед",
    "sendToBack": "На задний план",
    "bringToFront": "На передний план",
    "sendBackward": "Переместить назад",
    "delete": "Удалить",
    "copyStyles": "Скопировать стили",
    "pasteStyles": "Вставить стили",
    "stroke": "Обводка",
    "changeStroke": "Изменить цвет обводки",
    "background": "Фон",
    "changeBackground": "Изменить цвет фона",
    "fill": "Заливка",
    "strokeWidth": "Толщина штриха",
    "strokeStyle": "Стиль обводки",
    "strokeStyle_solid": "Сплошная",
    "strokeStyle_dashed": "Пунктирная",
    "strokeStyle_dotted": "Точечная",
    "sloppiness": "Стиль обводки",
    "opacity": "Непрозрачность",
    "textAlign": "Выравнивание текста",
    "edges": "Края",
    "sharp": "Острые",
    "round": "Скруглённые",
    "arrowheads": "Стрелка",
    "arrowhead_none": "Нет",
    "arrowhead_arrow": "Стрелка",
    "arrowhead_bar": "Черта",
    "arrowhead_circle": "Круг",
    "arrowhead_circle_outline": "Круг (контур)",
    "arrowhead_triangle": "Треугольник",
    "arrowhead_triangle_outline": "Треугольник (контур)",
    "arrowhead_diamond": "Ромб",
    "arrowhead_diamond_outline": "Ромб (контур)",
    "arrowhead_crowfoot_many": "Морщинки (много)",
    "arrowhead_crowfoot_one": "Морщинки (одна)",
    "arrowhead_crowfoot_one_or_many": "Морщинки (одна или много)",
    "more_options": "Больше вариантов",
    "arrowtypes": "Тип стрелки",
    "arrowtype_sharp": "Острая стрелка",
    "arrowtype_round": "Изогнутая стрелка",
    "arrowtype_elbowed": "Прямоугольная стрелка",
    "fontSize": "Размер шрифта",
    "fontFamily": "Семейство шрифтов",
    "addWatermark": "Добавить «Создано в Excalidraw»",
    "handDrawn": "От руки",
    "normal": "Обычный",
    "code": "Код",
    "small": "Малый",
    "medium": "Средний",
    "large": "Большой",
    "veryLarge": "Очень большой",
    "solid": "Однотонная",
    "hachure": "Штрихованная",
    "zigzag": "Зигзаг",
    "crossHatch": "Перекрестная",
    "thin": "Тонкая",
    "bold": "Жирная",
    "left": "Слева",
    "center": "Центр",
    "right": "Справа",
    "extraBold": "Очень жирная",
    "architect": "Архитектор",
    "artist": "Художник",
    "cartoonist": "Карикатурист",
    "fileTitle": "Имя файла",
    "colorPicker": "Выбор цвета",
    "canvasColors": "Используется на холсте",
    "canvasBackground": "Фон холста",
    "drawingCanvas": "Полотно",
    "clearCanvas": "Очистить холст",
    "layers": "Слои",
    "actions": "Действия",
    "language": "Язык",
    "liveCollaboration": "Онлайн взаимодействие...",
    "duplicateSelection": "Дубликат",
    "untitled": "Безымянный",
    "name": "Имя",
    "yourName": "Ваше имя",
    "madeWithExcalidraw": "Сделано в Excalidraw",
    "group": "Сгруппировать выделение",
    "ungroup": "Разделить выделение",
    "collaborators": "Участники",
    "toggleGrid": "Переключить сетку",
    "addToLibrary": "Добавить в библиотеку",
    "removeFromLibrary": "Удалить из библиотеки",
    "libraryLoadingMessage": "Загрузка библиотеки…",
    "libraries": "Просмотреть библиотеки",
    "loadingScene": "Загрузка сцены…",
    "loadScene": "Загрузить сцену из файла",
    "align": "Выровнять",
    "alignTop": "Выровнять по верхнему краю",
    "alignBottom": "Выровнять по нижнему краю",
    "alignLeft": "Выровнять по левому краю",
    "alignRight": "Выровнять по правому краю",
    "centerVertically": "Центрировать по вертикали",
    "centerHorizontally": "Центрировать по горизонтали",
    "distributeHorizontally": "Распределить по горизонтали",
    "distributeVertically": "Распределить по вертикали",
    "flipHorizontal": "Переворот по горизонтали",
    "flipVertical": "Переворот по вертикали",
    "viewMode": "Вид",
    "share": "Поделиться",
    "showStroke": "Показать выбор цвета обводки",
    "showBackground": "Показать выбор цвета фона",
    "showFonts": "Показать выбор шрифта",
    "toggleTheme": "Переключить светлую/тёмную тему",
    "theme": "Тема",
    "personalLib": "Личная библиотека",
    "excalidrawLib": "Библиотека Excalidraw",
    "decreaseFontSize": "Уменьшить шрифт",
    "increaseFontSize": "Увеличить шрифт",
    "unbindText": "Отвязать текст",
    "bindText": "Привязать текст к контейнеру",
    "createContainerFromText": "Поместить текст в контейнер",
    "link": {
      "edit": "Редактировать ссылку",
      "editEmbed": "Редактировать встраиваемую ссылку",
      "create": "Добавить ссылку",
      "label": "Ссылка",
      "labelEmbed": "Ссылка и встраивание",
      "empty": "Ссылка не установлена",
      "hint": "Введите или вставьте ссылку здесь",
      "goToElement": "Перейти к элементу"
    },
    "lineEditor": {
      "edit": "Редактирование строки",
      "editArrow": "Изменить стрелку"
    },
    "polygon": {
      "breakPolygon": "Разбить полигон",
      "convertToPolygon": "Преобразовать в полигон"
    },
    "elementLock": {
      "lock": "Блокировать",
      "unlock": "Разблокировать",
      "lockAll": "Заблокировать все",
      "unlockAll": "Разблокировать все"
    },
    "statusPublished": "Опубликовано",
    "sidebarLock": "Держать боковую панель открытой",
    "selectAllElementsInFrame": "Выбрать все элементы фрейма",
    "removeAllElementsFromFrame": "Убрать все элементы из фрейма",
    "eyeDropper": "Взять образец цвета с холста",
    "textToDiagram": "Текст в диаграмму",
    "prompt": "Промпт",
    "followUs": "Подписаться",
    "discordChat": "Чат в Discord",
    "zoomToFitViewport": "Масштабировать до области просмотра",
    "zoomToFitSelection": "Увеличить до выделенного",
    "zoomToFit": "Приблизьте все элементы",
    "installPWA": "Установить Excalidraw локально (PWA)",
    "autoResize": "Включить автоизменение размера текста",
    "imageCropping": "Обрезка изображения",
    "unCroppedDimension": "Необрезанный размер",
    "copyElementLink": "Скопировать ссылку на объект",
    "linkToElement": "Ссылка на объект",
    "wrapSelectionInFrame": "Поместить выделенное в фрейм",
    "tab": "Вкладка",
    "shapeSwitch": "Сменить форму"
  },
  "elementLink": {
    "title": "Ссылка на объект",
    "desc": "Нажмите на фигуру на холсте или вставьте ссылку.",
    "notFound": "Связанный объект не найден на холсте."
  },
  "library": {
    "noItems": "Пока ничего не добавлено...",
    "hint_emptyLibrary": "Выберите объект на холсте, чтобы добавить его сюда, или установите библиотеку из публичного репозитория ниже.",
    "hint_emptyPrivateLibrary": "Выберите объект на холсте, чтобы добавить его сюда.",
    "search": {
      "inputPlaceholder": "Поиск в библиотеке",
      "heading": "Совпадения в библиотеке",
      "noResults": "Совпадения не найдены...",
      "clearSearch": "Очистить поиск"
    }
  },
  "search": {
    "title": "Найти на холсте",
    "noMatch": "Совпадения не найдены...",
    "singleResult": "результат",
    "multipleResults": "результатов",
    "placeholder": "Найти текст на холсте...",
    "frames": "Рамки",
    "texts": "Текст"
  },
  "buttons": {
    "clearReset": "Очистить холст и сбросить цвет фона",
    "exportJSON": "Сохранить в",
    "exportImage": "Экспортировать изображение...",
    "export": "Сохранить как...",
    "copyToClipboard": "Скопировать в буфер обмена",
    "copyLink": "Скопировать ссылку",
    "save": "Сохранить в текущий файл",
    "saveAs": "Сохранить как",
    "load": "Открыть",
    "getShareableLink": "Получить доступ по ссылке",
    "close": "Закрыть",
    "selectLanguage": "Выбрать язык",
    "scrollBackToContent": "Вернуться к содержимому",
    "zoomIn": "Увеличить",
    "zoomOut": "Уменьшить",
    "resetZoom": "Сбросить масштаб",
    "menu": "Меню",
    "done": "Готово",
    "edit": "Изменить",
    "undo": "Шаг назад",
    "redo": "Шаг вперёд",
    "resetLibrary": "Сброс библиотеки",
    "createNewRoom": "Создать новую комнату",
    "fullScreen": "Полный экран",
    "darkMode": "Тёмная тема",
    "lightMode": "Светлая тема",
    "systemMode": "Системный режим",
    "zenMode": "Режим «Дзен»",
    "objectsSnapMode": "Привязка к объектам",
    "exitZenMode": "Отключить режим «Дзен»",
    "cancel": "Отменить",
    "saveLibNames": "Сохранить названия и выйти",
    "clear": "Очистить",
    "remove": "Удалить",
    "embed": "Включить встраивание",
    "publishLibrary": "Переименовать или опубликовать",
    "submit": "Отправить",
    "confirm": "Подтвердить",
    "embeddableInteractionButton": "Нажмите для взаимодействия"
  },
  "alerts": {
    "clearReset": "Это очистит весь холст. Вы уверены?",
    "couldNotCreateShareableLink": "Не удалось создать общедоступную ссылку.",
    "couldNotCreateShareableLinkTooBig": "Нельзя создать ссылку, чтобы поделиться. Сцена слишком большая",
    "couldNotLoadInvalidFile": "Не удалось загрузить недопустимый файл",
    "importBackendFailed": "Не удалось импортировать с сервера.",
    "cannotExportEmptyCanvas": "Не может экспортировать пустой холст.",
    "couldNotCopyToClipboard": "Не удалось скопировать в буфер обмена.",
    "decryptFailed": "Не удалось расшифровать данные.",
    "uploadedSecurly": "Загружаемые данные защищена сквозным шифрованием, что означает, что сервер Excalidraw и третьи стороны не могут прочитать содержимое.",
    "loadSceneOverridePrompt": "Загрузка рисунка приведёт к замене имеющегося содержимого. Вы хотите продолжить?",
    "collabStopOverridePrompt": "Остановка сессии перезапишет ваш предыдущий, локально сохранённый рисунок. Вы уверены? \n\n(Если вы хотите оставить ваш локальный рисунок, просто закройте вкладку браузера).",
    "errorAddingToLibrary": "Не удалось добавить объект в библиотеку",
    "errorRemovingFromLibrary": "Не удалось удалить объект из библиотеки",
    "confirmAddLibrary": "Будут добавлены фигуры ({{numShapes}}) в вашу библиотеку. Продолжить?",
    "imageDoesNotContainScene": "Это изображение не содержит данных сцены. Вы включили встраивание сцены во время экспорта?",
    "cannotRestoreFromImage": "Сцена не может быть восстановлена из этого изображения",
    "invalidSceneUrl": "Невозможно импортировать сцену с предоставленного URL. Неверный формат, или не содержит верных Excalidraw JSON данных.",
    "resetLibrary": "Это очистит вашу библиотеку. Вы уверены?",
    "removeItemsFromsLibrary": "Удалить объекты ({{count}}) из библиотеки?",
    "invalidEncryptionKey": "Ключ шифрования должен состоять из 22 символов. Одновременное редактирование отключено.",
    "collabOfflineWarning": "Отсутствует интернет-соединение.\nВаши изменения не будут сохранены!",
    "localStorageQuotaExceeded": "Превышена квота хранения браузера. Изменения не будут сохранены."
  },
  "errors": {
    "unsupportedFileType": "Неподдерживаемый тип файла.",
    "imageInsertError": "Не удалось вставить изображение. Попробуйте позже...",
    "fileTooBig": "Очень большой файл. Максимально разрешённый размер – {{maxSize}}.",
    "svgImageInsertError": "Не удалось вставить изображение SVG. Разметка SVG выглядит недействительной.",
    "failedToFetchImage": "Не удалось получить изображение.",
    "cannotResolveCollabServer": "Не удалось подключиться к серверу совместного редактирования. Перезагрузите страницу и повторите попытку.",
    "importLibraryError": "Не удалось загрузить библиотеку",
    "saveLibraryError": "Не удалось сохранить библиотеку в хранилище. Пожалуйста, сохраните библиотеку в файл локально, чтобы не потерять изменения.",
    "collabSaveFailed": "Не удалось сохранить в базу данных. Если проблема повторится, нужно будет сохранить файл локально, чтобы быть уверенным, что вы не потеряете вашу работу.",
    "collabSaveFailed_sizeExceeded": "Не удалось сохранить в базу данных. Похоже, что холст слишком большой. Нужно сохранить файл локально, чтобы быть уверенным, что вы не потеряете вашу работу.",
    "imageToolNotSupported": "Изображения отключены.",
    "brave_measure_text_error": {
      "line1": "Похоже, вы используете браузер Brave с включённой настройкой <bold>«Агрессивное блокирование определения отпечатков»</bold>.",
      "line2": "Это может привести к поломке <bold>текстовых объектов</bold> на рисунке.",
      "line3": "Мы настоятельно рекомендуем отключить эту настройку. Для этого нужно выполнить <link>эти шаги</link>.",
      "line4": "Если отключение этой настройки не исправит отображение текстовых объектов, создайте <issueLink>Issue</issueLink> на нашем GitHub или напишите нам в <discordLink>Discord</discordLink>"
    },
    "libraryElementTypeError": {
      "embeddable": "Встраиваемые элементы не могут быть добавлены в библиотеку.",
      "iframe": "Элементы IFrame не могут быть добавлены в библиотеку.",
      "image": "Поддержка добавления изображений в библиотеку скоро будет доступна!"
    },
    "asyncPasteFailedOnRead": "Не удалось вставить (невозможно прочитать из системного буфера обмена).",
    "asyncPasteFailedOnParse": "Не удалось вставить.",
    "copyToSystemClipboardFailed": "Не удалось скопировать в буфер обмена."
  },
  "toolBar": {
    "selection": "Выделение области",
    "lasso": "Выделение лассо",
    "image": "Вставить изображение",
    "rectangle": "Прямоугольник",
    "diamond": "Ромб",
    "ellipse": "Эллипс",
    "arrow": "Cтрелка",
    "line": "Линия",
    "freedraw": "Чертить",
    "text": "Текст",
    "library": "Библиотека",
    "lock": "Сохранять выбранный инструмент активным после рисования",
    "penMode": "Режим пера – предотвращение касания",
    "link": "Добавить / Обновить ссылку для выбранной фигуры",
    "eraser": "Ластик",
    "frame": "Фреймовый инструмент",
    "magicframe": "Каркас для кода",
    "embeddable": "Встроенная страница",
    "laser": "Лазерная указка",
    "hand": "Рука (перемещение холста)",
    "extraTools": "Дополнительные инструменты",
    "mermaidToExcalidraw": "Mermaid в Excalidraw",
    "convertElementType": "Переключение типа формы"
  },
  "element": {
    "rectangle": "Прямоугольник",
    "diamond": "Ромб",
    "ellipse": "Эллипс",
    "arrow": "Стрелка",
    "line": "Линия",
    "freedraw": "Свободное рисование",
    "text": "Текст",
    "image": "Изображение",
    "group": "Группа",
    "frame": "Фрейм",
    "magicframe": "Каркас для кода",
    "embeddable": "Встроенная страница",
    "selection": "Выделение",
    "iframe": "IFrame"
  },
  "headings": {
    "canvasActions": "Операции холста",
    "selectedShapeActions": "Операции выбранной фигуры",
    "shapes": "Фигуры"
  },
  "hints": {
    "dismissSearch": "{{shortcut}} — отменить поиск",
    "canvasPanning": "Чтобы переместить холст, удерживайте {{shortcut_1}} или {{shortcut_2}} во время перетаскивания или используйте инструмент «Рука»",
    "linearElement": "Нажмите, чтобы начать несколько точек, перетащите для одной линии",
    "arrowTool": "Нажмите, чтобы начать рисование нескольких точек, перетащите для одной линии. Нажмите {{shortcut}} снова, чтобы изменить тип стрелки.",
    "arrowBindModifiers": "Удерживайте {{shortcut_1}} , чтобы отключить привязку, или {{shortcut_2}} для привязки в фиксированной точке",
    "freeDraw": "Нажмите и перетаскивайте, отпустите по завершении",
    "text": "Совет: при выбранном инструменте выделения дважды щёлкните в любом месте, чтобы добавить текст",
    "embeddable": "Перетащите для встраивания веб-сайта",
    "text_selected": "Дважды щёлкните или нажмите {{shortcut}}, чтобы отредактировать текст",
    "text_editing": "Нажмите {{shortcut_1}} или {{shortcut_2}}, чтобы завершить редактирование",
    "linearElementMulti": "Нажмите на последнюю точку или нажмите {{shortcut_1}} или {{shortcut_2}}, чтобы завершить",
    "lockAngle": "Вы можете ограничить угол, удерживая {{shortcut}}",
    "resize": "Вы можете ограничить пропорции, удерживая {{shortcut_1}} во время изменения размера,\nудерживайте {{shortcut_2}}, чтобы изменить размер от центра",
    "resizeImage": "Вы можете свободно изменять размер, удерживая {{shortcut_1}},\nудерживайте {{shortcut_2}}, чтобы изменить размер от центра",
    "rotate": "Вы можете ограничить углы, удерживая {{shortcut}} во время поворота",
    "lineEditor_info": "Удерживайте {{shortcut_1}} и дважды щёлкните или нажмите {{shortcut_2}}, чтобы отредактировать точки",
    "lineEditor_line_info": "Дважды щёлкните или нажмите {{shortcut}}, чтобы отредактировать точки",
    "lineEditor_pointSelected": "Нажмите {{shortcut_1}}, чтобы удалить точки,\n{{shortcut_2}} для дублирования или перетащите",
    "lineEditor_nothingSelected": "Выберите точку для редактирования (удерживайте {{shortcut_1}}, чтобы выбрать несколько),\nили удерживайте {{shortcut_2}} и щёлкните, чтобы добавить новые точки",
    "publishLibrary": "Опубликовать свою собственную библиотеку",
    "bindTextToElement": "{{shortcut}} — добавить текст",
    "createFlowchart": "{{shortcut}} — создать блок-схему",
    "deepBoxSelect": "Удерживайте {{shortcut}} для глубокого выделения и предотвращения перетаскивания",
    "eraserRevert": "Удерживайте {{shortcut}}, чтобы восстановить элементы, помеченные для удаления",
    "firefox_clipboard_write": "Эта функция может быть включена при изменении значения флага «dom.events.asyncClipboard.clipboardItem» на «true». Чтобы изменить флаги браузера в Firefox, зайдите на страницу «about:config».",
    "disableSnapping": "Удерживайте {{shortcut}}, чтобы отключить привязку",
    "enterCropEditor": "Дважды щёлкните по изображению или нажмите {{shortcut}}, чтобы обрезать изображение",
    "leaveCropEditor": "Щёлкните за пределами изображения или нажмите {{shortcut_1}} или {{shortcut_2}}, чтобы завершить кадрирование"
  },
  "canvasError": {
    "cannotShowPreview": "Не удалось отобразить предпросмотр",
    "canvasTooBig": "Сцена слишком большая.",
    "canvasTooBigTip": "Совет: попробуйте сблизить элементы рисунка."
  },
  "errorSplash": {
    "headingMain": "Возникла ошибка. Попробуйте <button>перезагрузить страницу</button>.",
    "clearCanvasMessage": "Если перезагрузка страницы не помогла, попробуйте <button>очистить холст</button>.",
    "clearCanvasCaveat": " Текущая работа будет утеряна ",
    "trackedToSentry": "Ошибка с идентификатором {{eventId}} отслеживается в нашей системе.",
    "openIssueMessage": "Для безопасности информация о вашей сцене не включена в ошибку. Если в сцене нет ничего конфиденциального, пожалуйста следуйте нашему <button>баг трекеру</button>. Пожалуйста, приложите информацию ниже, скопировав и вставив её, в Issue на GitHub.",
    "sceneContent": "Содержание сцены:"
  },
  "shareDialog": {
    "or": "Или"
  },
  "roomDialog": {
    "desc_intro": "Пригласить людей для участия в рисовании.",
    "desc_privacy": "Не волнуйтесь, сеанс защищён сквозным шифрованием и полностью приватный. Даже наш сервер не сможет увидеть, что вы рисуете.",
    "button_startSession": "Начать сеанс",
    "button_stopSession": "Завершить сеанс",
    "desc_inProgressIntro": "Сеанс совместной работы запущен.",
    "desc_shareLink": "Поделитесь этой ссылкой со всеми участниками:",
    "desc_exitSession": "Завершив сеанс, вы выйдете из комнаты, но сможете продолжить работать с документом локально. Это не повлияет на работу других пользователей — они смогут продолжить совместную работу с их версией документа.",
    "shareTitle": "Присоединиться к активной совместной сессии на Excalidraw"
  },
  "errorDialog": {
    "title": "Ошибка"
  },
  "exportDialog": {
    "disk_title": "Сохранить на диск",
    "disk_details": "Экспортировать данные сцены в файл, из которого можно импортировать позже.",
    "disk_button": "Сохранить в файл",
    "link_title": "Поделитесь ссылкой",
    "link_details": "Экспорт ссылки только для чтения.",
    "link_button": "Экспорт в ссылку",
    "excalidrawplus_description": "Сохраните сцену в ваше рабочее пространство Excalidraw+.",
    "excalidrawplus_button": "Экспорт",
    "excalidrawplus_exportError": "Не удалось экспортировать в Excalidraw+ на данный момент..."
  },
  "helpDialog": {
    "blog": "Прочитайте наш блог",
    "click": "нажать",
    "deepSelect": "Глубокое выделение",
    "deepBoxSelect": "Глубокое выделение рамкой, и предотвращение перетаскивания",
    "createFlowchart": "Создать диаграмму из базового элемента",
    "navigateFlowchart": "Навигация по диаграмме",
    "curvedArrow": "Изогнутая стрелка",
    "curvedLine": "Изогнутая линия",
    "documentation": "Документация",
    "doubleClick": "двойной щелчок",
    "drag": "перетащить",
    "editor": "Редактор",
    "editLineArrowPoints": "Редактировать концы линий/стрелок",
    "editText": "Редактировать текст / добавить метку",
    "github": "Нашли проблему? Отправьте",
    "howto": "Следуйте нашим инструкциям",
    "or": "или",
    "preventBinding": "Предотвращать привязку стрелок",
    "tools": "Инструменты",
    "shortcuts": "Горячие клавиши",
    "textFinish": "Закончить редактирование (текстовый редактор)",
    "textNewLine": "Добавить новую строку (текстовый редактор)",
    "title": "Справка",
    "view": "Просмотр",
    "zoomToFit": "Отмастштабировать, чтобы поместились все элементы",
    "zoomToSelection": "Увеличить до выделенного",
    "toggleElementLock": "Заблокировать/разблокировать выделение",
    "movePageUpDown": "Сдвинуть страницу вверх/вниз",
    "movePageLeftRight": "Сдвинуть страницу вправо/влево",
    "cropStart": "Обрезать изображение",
    "cropFinish": "Закончить обрезку изображения"
  },
  "clearCanvasDialog": {
    "title": "Очистить холст"
  },
  "publishDialog": {
    "title": "Опубликовать библиотеку",
    "itemName": "Название объекта",
    "authorName": "Имя автора",
    "githubUsername": "Имя пользователя GitHub",
    "twitterUsername": "Имя пользователя в Твиттере",
    "libraryName": "Название библиотеки",
    "libraryDesc": "Описание библиотеки",
    "website": "Веб-сайт",
    "placeholder": {
      "authorName": "Ваше имя или имя пользователя",
      "libraryName": "Название вашей библиотеки",
      "libraryDesc": "Описание вашей библиотеки, которое поможет людям понять её назначение",
      "githubHandle": "Имя пользователя GitHub (необязательно), чтобы вы смогли редактировать библиотеку после её отправки на проверку",
      "twitterHandle": "Имя пользователя в Твиттере (необязательно), чтобы мы знали, кого упомянуть при продвижении в Твиттере",
      "website": "Ссылка на ваш личный или какой-то другой сайт (необязательно)"
    },
    "errors": {
      "required": "Обязательно",
      "website": "Введите допустимый URL-адрес"
    },
    "noteDescription": "Отправить вашу библиотеку для включения в <link>хранилище публичных библиотек</link>, чтобы другие люди могли использовать объекты из вашей библиотеки в своих рисунках.",
    "noteGuidelines": "Библиотека должна быть подтверждена вручную. Пожалуйста, прочтите <link>рекомендации</link> перед отправкой. Вам понадобится учётная запись GitHub, чтобы общаться и вносить изменения при необходимости, но это не обязательно.",
    "noteLicense": "Выполняя отправку, вы соглашаетесь с тем, что библиотека будет опубликована под <link>лицензией MIT</link>, что, вкратце, означает, что каждый может использовать её без ограничений.",
    "noteItems": "Каждый объект в библиотеке должен иметь своё собственное имя, чтобы по нему можно было фильтровать. Следующие объекты библиотеки будут включены:",
    "atleastOneLibItem": "Пожалуйста, выберите хотя бы один объект в библиотеке, чтобы начать",
    "republishWarning": "Примечание: некоторые из выбранных элементов помечены как уже опубликованные/отправленные. Вы должны повторно отправить элементы только при обновлении существующей библиотеки или сдаче работы."
  },
  "publishSuccessDialog": {
    "title": "Библиотека отправлена",
    "content": "Благодарим вас, {{authorName}}. Ваша библиотека была отправлена на проверку. Вы можете отслеживать статус <link>здесь</link>"
  },
  "confirmDialog": {
    "resetLibrary": "Сброс библиотеки",
    "removeItemsFromLib": "Удалить выбранные объекты из библиотеки"
  },
  "imageExportDialog": {
    "header": "Экспортировать изображение",
    "label": {
      "withBackground": "Фон",
      "onlySelected": "Только выделенное",
      "darkMode": "Тёмная тема",
      "embedScene": "Встроить сцену",
      "scale": "Масштаб",
      "padding": "Отступ"
    },
    "tooltip": {
      "embedScene": "Сцена будет сохранена в PNG/SVG файл так, чтобы всю сцену можно будет восстановить из этого файла. Это увеличит размер файла."
    },
    "title": {
      "exportToPng": "Экспорт в PNG",
      "exportToSvg": "Экспорт в SVG",
      "copyPngToClipboard": "Скопировать PNG в буфер обмена"
    },
    "button": {
      "exportToPng": "PNG",
      "exportToSvg": "SVG",
      "copyPngToClipboard": "Скопировать в буфер обмена"
    }
  },
  "encrypted": {
    "tooltip": "Ваши данные защищены сквозным (End-to-end) шифрованием. Серверы Excalidraw никогда не получат доступ к ним.",
    "link": "Запись блога о сквозном шифровании в Excalidraw"
  },
  "stats": {
    "angle": "Угол",
    "shapes": "Фигуры",
    "height": "Высота",
    "scene": "Сцены",
    "selected": "Выбран",
    "storage": "Хранилище",
    "fullTitle": "Свойства холста и фигуры",
    "title": "Свойства",
    "generalStats": "Общее",
    "elementProperties": "Свойства формы",
    "total": "Всего",
    "version": "Версия",
    "versionCopy": "Копировать",
    "versionNotAvailable": "Версия не доступна",
    "width": "Ширина"
  },
  "toast": {
    "addedToLibrary": "Добавлено в библиотеку",
    "copyStyles": "Скопированы стили.",
    "copyToClipboard": "Скопировано в буфер обмена.",
    "copyToClipboardAsPng": "{{exportSelection}} скопировано как PNG ({{exportColorScheme}})",
    "copyToClipboardAsSvg": "{{exportSelection}} скопировано в буфер обмена как SVG\n({{exportColorScheme}})",
    "fileSaved": "Файл сохранён.",
    "fileSavedToFilename": "Сохранено в {filename}",
    "canvas": "холст",
    "selection": "выделение",
    "pasteAsSingleElement": "Используйте {{shortcut}}, чтобы вставить один объект,\nили вставьте в существующий текстовый редактор",
    "unableToEmbed": "Встраивание этого URL в данный момент не разрешено. Сделайте Issue на GitHub для добавления URL в белый список",
    "unrecognizedLinkFormat": "Ссылка, которую вы ввели не соответствует ожидаемому формату. Пожалуйста, попробуйте вставить строку «встраивание», предоставленную исходным сайтом",
    "elementLinkCopied": "Ссылка скопирована в буфер обмена"
  },
  "colors": {
    "transparent": "Прозрачный",
    "black": "Чёрный",
    "white": "Белый",
    "red": "Красный",
    "pink": "Розовый",
    "grape": "Виноградный",
    "violet": "Фиолетовый",
    "gray": "Серый",
    "blue": "Синий",
    "cyan": "Голубой",
    "teal": "Бирюзовый",
    "green": "Зелёный",
    "yellow": "Жёлтый",
    "orange": "Оранжевый",
    "bronze": "Бронзовый"
  },
  "welcomeScreen": {
    "app": {
      "center_heading": "",
      "center_heading_line2": "",
      "center_heading_line3": "",
      "center_heading_plus": "Хотите перейти на Excalidraw+?",
      "menuHint": "Экспорт, настройки, языки, ..."
    },
    "defaults": {
      "menuHint": "Экспорт, настройки и другое...",
      "center_heading": "Диаграммы. Просто.",
      "toolbarHint": "Выберите инструмент и начните рисовать!",
      "helpHint": "Сочетания клавиш и справка"
    }
  },
  "colorPicker": {
    "color": "Цвет",
    "mostUsedCustomColors": "Часто используемые пользовательские цвета",
    "colors": "Цвета",
    "shades": "Оттенки",
    "hexCode": "Шестнадцатеричный код",
    "noShades": "Нет доступных оттенков для этого цвета"
  },
  "overwriteConfirm": {
    "action": {
      "exportToImage": {
        "title": "Экспортировать как изображение",
        "button": "Экспортировать как изображение",
        "description": "Экспортируйте данные сцены как изображение, из которого вы сможете импортировать позже."
      },
      "saveToDisk": {
        "title": "Сохранить на диск",
        "button": "Сохранить на диск",
        "description": "Экспортировать данные сцены в файл, из которого можно импортировать позже."
      },
      "excalidrawPlus": {
        "title": "Excalidraw+",
        "button": "Экспорт в Excalidraw+",
        "description": "Сохраните сцену в ваше рабочее пространство Excalidraw+."
      }
    },
    "modal": {
      "loadFromFile": {
        "title": "Загрузить из файла",
        "button": "Загрузить из файла",
        "description": "Загрузка из файла <bold>заменит существующее содержимое</bold>.<br></br>Вы можете сначала создать резервную копию своего рисунка, используя один из приведённых ниже вариантов."
      },
      "shareableLink": {
        "title": "Загрузить по ссылке",
        "button": "Заменить содержимое",
        "description": "Загрузка внешнего рисунка <bold>заменит существующее содержимое</bold>.<br></br>Вы можете сначала создать резервную копию своего рисунка, используя один из приведённых ниже вариантов."
      }
    }
  },
  "mermaid": {
    "title": "Из Mermaid в Excalidraw",
    "button": "Вставить",
    "description": "В настоящее время поддерживаются только <flowchartLink>блок-схемы</flowchartLink>, <sequenceLink>диаграммы последовательности</sequenceLink> и <classLink>диаграммы классов</classLink>. Другие типы будут отображаться в виде изображения в Excalidraw.",
    "syntax": "Синтаксис Mermaid",
    "preview": "Предпросмотр",
    "label": "Mermaid",
    "inputPlaceholder": "Напишите здесь определение диаграммы Mermaid..."
  },
  "ttd": {
    "error": "Ошибка!"
  },
  "chat": {
    "inputPlaceholder": "Начните вводить сюда идею диаграммы... ({{shortcut}} для новой строки)",
    "inputPlaceholderWithMessages": "Продолжайте доработку диаграммы...",
    "generating": "",
    "rateLimitRemaining": "Осталось запросов сегодня: {{count}}",
    "role": {
      "user": "Вы",
      "assistant": "ИИ-помощник",
      "system": "Система"
    },
    "aiBeta": "ИИ-бета",
    "label": "Чат",
    "menu": "Меню",
    "newChat": "Новый чат",
    "deleteChat": "Удалить чат",
    "deleteMessage": "Удалить сообщение",
    "viewAsMermaid": "Просмотреть как Mermaid",
    "placeholder": {
      "title": "Давайте создадим вашу диаграмму",
      "description": "Опишите диаграмму, которую вы хотите создать, и мы сгенерируем её для вас.",
      "hint": "На данный момент мы знаем диаграммы блок-схемы, последовательности и классов."
    },
    "preview": "Предпросмотр",
    "insert": "Вставить",
    "retry": "Повторить",
    "errors": {
      "promptTooShort": "Подсказка слишком короткая (мин. символов: {{min}})",
      "promptTooLong": "Подсказка слишком длинная (макс. символов: {{max}})",
      "generationFailed": "Генерация не удалась",
      "invalidDiagram": "Сгенерирована неверная диаграмма :(. Вы можете редактировать вручную, повторите с автоисправлением или попробуйте другую подсказку.",
      "fixInMermaid": "Изменить Mermaid вручную →",
      "aiRepair": "Перегенерировать (автоисправление) →",
      "requestAborted": "Запрос отменён",
      "requestFailed": "Запрос не удался",
      "mermaidParseError": ""
    },
    "rateLimit": {
      "messageLimit": "Вы достигли лимита ИИ на бесплатном тарифном плане. Попробуйте Excalidraw+ или вернитесь завтра.",
      "generalRateLimit": "Подождите, вы слишком быстры для нас! Пожалуйста, подождите немного, прежде чем повторить попытку.",
      "messageLimitInputPlaceholder": "Вы достигли лимита сообщений"
    },
    "upsellBtnLabel": "Перейти на Plus"
  },
  "quickSearch": {
    "placeholder": "Быстрый поиск"
  },
  "fontList": {
    "badge": {
      "old": "старый"
    },
    "sceneFonts": "В этой сцене",
    "availableFonts": "Доступные шрифты",
    "empty": "Шрифты не найдены"
  },
  "userList": {
    "empty": "Пользователи не найдены",
    "hint": {
      "text": "Нажмите на пользователя, чтобы подписаться",
      "followStatus": "Вы подписаны на этого пользователя",
      "inCall": "Пользователь находится в голосовом звонке",
      "micMuted": "Микрофон пользователя заглушён",
      "isSpeaking": "Пользователь говорит"
    }
  },
  "commandPalette": {
    "title": "Палитра команд",
    "shortcuts": {
      "select": "Выбрать",
      "confirm": "Подтвердить",
      "close": "Закрыть"
    },
    "recents": "Недавно использованные",
    "search": {
      "placeholder": "Поиск меню, команд и скрытых сокровищ",
      "noMatch": "Нет подходящих команд..."
    },
    "itemNotAvailable": "Команда недоступна...",
    "shortcutHint": "Используйте {{shortcut}} для командной палитры"
  },
  "keys": {
    "ctrl": "Ctrl",
    "option": "Option",
    "cmd": "Cmd",
    "alt": "Alt",
    "escape": "Esc",
    "enter": "Enter",
    "shift": "Shift",
    "spacebar": "Пробел",
    "delete": "Delete",
    "mmb": "Колёсико мыши"
  }
}
